<template>
    <div class="w-full">
        <div class="flex w-full">
            <Link :href="route('profile')" class="grow">
                <div class="flex items-center">
                    <div>
                        <img class="inline-block h-10 w-10 rounded-full"
                             v-if="profile.profileImage && profile.profileImage.length > 0"
                             :src="profile.profileImage"
                             :alt="profile.fullName">
                        <icon v-if="!profile.profileImage || profile.profileImage.length < 1"
                              name="user"
                              class="w-10 h-10 fill-white"/>
                    </div>
                    <div class="ml-3">
                        <p class="text-base font-medium text-white">{{profile.fullName}}</p>
                        <p class="text-sm font-medium text-gray-400 group-hover:text-gray-300">{{$t('shared.profile.view_profile')}}</p>

                        <div class="pt-3 justify-start text-sm font-medium text-gray-400 group-hover:text-gray-300 w-full flex ">
                            <Link :href="route('logout')"
                               class="justify-end self-center"
                               v-if="profile.fullName && profile.fullName.length > 0">
                                {{$t('shared.profile.logout')}}
                            </Link>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon';
import { Link } from '@inertiajs/vue2';

export default {
    components: {
        Icon,
        Link
    },
    props: {
        profile: Object
    }
}
</script>
